import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../store';
import { EmployeeDataState, EmployeeDataResponse, AccountUpdateRequest, EmailVerificationRequest } from '../../store/employeeData/types';
import { maskUSPhoneInput, addressMaster, takeOnlyDigitAndPlus } from '../../utils/global';
import { getCookie, attachHeader } from '../../utils';
import { toast } from 'react-toastify';
import { accountUpdatePending, emailVerificationPendingAction } from '../../store/employeeData/actions';
import { emailValidator } from '../../utils/validators';
import Helmet from 'react-helmet';
import { TITLES_LABELS } from '../../constants';
import { Animated } from "react-animated-css";
import PinInput from 'react-pin-input';
import Axios from 'axios';
import apiConfigs from '../../configs/apiConfigs';
import { Button, Modal, Spinner } from 'react-bootstrap';

interface Props {
    employeeDataState: EmployeeDataState;
    accountUpdate: typeof accountUpdatePending;
    emailVerification: typeof emailVerificationPendingAction;
}
interface State {
    employeeData?: EmployeeDataResponse;
    currentActiveCard: number;
    originalEmployeeData?: EmployeeDataResponse;
    newEmailAddress: string;
    confirmNewEmailAddress: string;
    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    cardZeroValidation: { valid: boolean, field: number, msg: string },
    cardOneValidation: { valid: boolean, msg: string },
    cardTwoValidation: { valid: boolean, field: number, msg: string },
    cardThreeValidation: { valid: boolean, field: number, msg: string },
    cardFourValidation: { valid: boolean, msg: string },
    cardFiveValiation: { valid: boolean, msg: string },
    cardSixValidaiton: { valid: boolean, msg: string },
    address: string;
    country: string;
    province: string;
    city: string;
    postalcode: string;
    provinceArray: [];
    phoneVerifyModal: boolean;
    verificationCode: string;
    intervalTime: number;
    verificationCodeFalse: boolean;
    loadingVerification: boolean;
    emailVerificationLoader: boolean;
}
class Account extends React.Component<Props, State> {
    monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    interval: any;
    constructor(props: any) {
        super(props);
        this.state = {
            currentActiveCard: -1,
            newEmailAddress: '', confirmNewEmailAddress: '',
            currentPassword: '', newPassword: '', confirmNewPassword: '',
            cardZeroValidation: { valid: true, field: -1, msg: '' },
            cardOneValidation: { valid: true, msg: '' },
            cardTwoValidation: { valid: true, field: -1, msg: '' },
            cardThreeValidation: { valid: true, field: -1, msg: '' },
            cardFourValidation: { valid: true, msg: '' },
            cardFiveValiation: { valid: true, msg: '' },
            cardSixValidaiton: { valid: true, msg: '' },
            address: '', city: '', country: '', postalcode: '', province: '',
            provinceArray: [], phoneVerifyModal: false, verificationCode: '',
            intervalTime: 30,
            verificationCodeFalse: false,
            loadingVerification: false,
            emailVerificationLoader: false,
        }
    }
    componentDidMount() {
        if (this.props.employeeDataState && this.props.employeeDataState.error === null &&
            this.props.employeeDataState.employeeDataResponse) {
            this.setState({
                originalEmployeeData: JSON.parse(JSON.stringify(this.props.employeeDataState.employeeDataResponse))
            });
            let maskedText = '';
            let phone = this.props.employeeDataState.employeeDataResponse.phone;
            console.log(phone);
            if (phone && phone !== "") {
                if (phone[0] === "+") {
                    phone = phone.substr(2, phone.length);
                }
                maskedText = maskUSPhoneInput(phone);
            }
            this.setState({
                employeeData: {
                    ...this.props.employeeDataState.employeeDataResponse,
                    phone: maskedText,
                },
                address: this.props.employeeDataState.employeeDataResponse.addressline1 + " " + this.props.employeeDataState.employeeDataResponse.addressline2,
                country: this.props.employeeDataState.employeeDataResponse.country,
                city: this.props.employeeDataState.employeeDataResponse.city,
                province: this.props.employeeDataState.employeeDataResponse.state,
                postalcode: this.props.employeeDataState.employeeDataResponse.postalCode,
            });
            if (addressMaster.states[this.props.employeeDataState.employeeDataResponse.country]) {
                this.setState({ provinceArray: addressMaster.states[this.props.employeeDataState.employeeDataResponse.country] });
            } else {
                this.setState({ provinceArray: [] });
            }
        }
    }
    resetAllFormData() {
        if (this.state.employeeData) {
            console.log('EmployeeData', this.state.originalEmployeeData ? this.state.originalEmployeeData.state : '');
            if (this.state.originalEmployeeData && this.state.originalEmployeeData.country && addressMaster.states[this.state.originalEmployeeData.country]) {
                this.setState({ provinceArray: addressMaster.states[this.state.originalEmployeeData.country] });
            } else {
                this.setState({ provinceArray: [] });
            }
            this.setState({
                address: (this.state.originalEmployeeData && this.state.originalEmployeeData.addressline1) ? this.state.originalEmployeeData.addressline1 + " " + this.state.originalEmployeeData.addressline2 : '',
                country: (this.state.originalEmployeeData && this.state.originalEmployeeData.country) ? this.state.originalEmployeeData.country : '',
                city: (this.state.originalEmployeeData && this.state.originalEmployeeData.city) ? this.state.originalEmployeeData.city : '',
                province: (this.state.originalEmployeeData && this.state.originalEmployeeData.state) ? this.state.originalEmployeeData.state : '',
                postalcode: (this.state.originalEmployeeData && this.state.originalEmployeeData.postalCode) ? this.state.originalEmployeeData.postalCode : '',
                employeeData: {
                    ...this.state.employeeData,
                    firstName: (this.state.originalEmployeeData && this.state.originalEmployeeData.firstName) ? this.state.originalEmployeeData.firstName : '',
                    lastName: (this.state.originalEmployeeData && this.state.originalEmployeeData.lastName) ? this.state.originalEmployeeData.lastName : '',
                    addressline1: (this.state.originalEmployeeData && this.state.originalEmployeeData.addressline1) ? this.state.originalEmployeeData.addressline1 : '',
                    addressline2: (this.state.originalEmployeeData && this.state.originalEmployeeData.addressline2) ? this.state.originalEmployeeData.addressline2 : '',
                    country: (this.state.originalEmployeeData && this.state.originalEmployeeData.country) ? this.state.originalEmployeeData.country : '',
                    postalCode: (this.state.originalEmployeeData && this.state.originalEmployeeData.postalCode) ? this.state.originalEmployeeData.postalCode : '',
                    state: (this.state.originalEmployeeData && this.state.originalEmployeeData.state) ? this.state.originalEmployeeData.state : '',
                    gender: (this.state.originalEmployeeData && this.state.originalEmployeeData.gender) ? this.state.originalEmployeeData.gender : 'Male',
                    dob: (this.state.originalEmployeeData && this.state.originalEmployeeData.dob) ? this.state.originalEmployeeData.dob : ''
                }
            })
        }
    }
    resetAllFormValidation() {
        this.setState({
            cardZeroValidation: { valid: true, field: -1, msg: '' },
            cardOneValidation: { valid: true, msg: '', },
            cardTwoValidation: { valid: true, field: -1, msg: '' },
            cardThreeValidation: { valid: true, field: -1, msg: '' },
            cardFourValidation: { valid: true, msg: '' },
            cardFiveValiation: { valid: true, msg: '' },
            cardSixValidaiton: { valid: true, msg: '' }
        })
    }
    handleFormClick(currentCard: number) {
        const login: any = getCookie();
        if (currentCard === 0) {
            if (this.state.employeeData) {
                if (!this.state.employeeData.firstName || this.state.employeeData.firstName === "") {
                    this.setState({ cardZeroValidation: { valid: false, field: 0, msg: 'First Name Required' } })
                    return;
                } else if (!this.state.employeeData.lastName || this.state.employeeData.lastName === "") {
                    this.setState({ cardZeroValidation: { valid: false, field: 1, msg: 'Last Name Required' } })
                    return;
                }
                this.props.accountUpdate({
                    // userId: login.id,
                    // uniqueId: login.uniqueId,
                    uniqueId: login.xpr_user_id,
                    updateType: 'name',
                    firstName: this.state.employeeData.firstName,
                    lastName: this.state.employeeData.lastName
                });
                this.resetAllFormValidation();
            }
        } else if (currentCard === 1) {
            if (this.state.employeeData) {
                if (!this.state.employeeData.phone || this.state.employeeData.phone === "") {
                    this.setState({ cardOneValidation: { valid: false, msg: 'Phone is required' } });
                    return;
                }
                let phone: string = takeOnlyDigitAndPlus(this.state.employeeData.phone);
                if (phone.length > 10 || phone.length < 10) {
                    this.setState({ cardOneValidation: { valid: false, msg: 'Invalid Phone' } });
                    return;
                }
                phone = "+1" + phone;
                this.props.accountUpdate({
                    // userId: login.id,
                    // uniqueId: login.uniqueId,
                    uniqueId: login.xpr_user_id,
                    updateType: 'phone',
                    phone: phone
                });
                this.resetAllFormValidation();
            }
        } else if (currentCard === 2) {
            if (this.state.employeeData) {
                if (this.state.newEmailAddress === "") {
                    this.setState({
                        cardTwoValidation: { valid: false, field: 0, msg: 'New Email is requried' }
                    });
                    return;
                } else if (this.state.confirmNewEmailAddress === "") {
                    this.setState({
                        cardTwoValidation: { valid: false, field: 1, msg: 'Confirm New Email is requried' }
                    });
                    return;
                } else if (!emailValidator(this.state.newEmailAddress)) {
                    this.setState({
                        cardTwoValidation: { valid: false, field: 0, msg: 'New Email is invalid' }
                    });
                    return;
                } else if (!emailValidator(this.state.confirmNewEmailAddress)) {
                    this.setState({
                        cardTwoValidation: { valid: false, field: 1, msg: 'Confirm New Email is invalid' }
                    });
                    return;
                } else if (this.state.confirmNewEmailAddress.trim() !== this.state.newEmailAddress.trim()) {
                    this.setState({
                        cardTwoValidation: { valid: false, field: 1, msg: 'Confirm New Email and New email should match' }
                    });
                    return;
                }
                this.props.accountUpdate({
                    // userId: login.id,
                    // uniqueId: login.uniqueId,
                    uniqueId: login.xpr_user_id,
                    updateType: 'email',
                    email: this.state.newEmailAddress
                });
                this.resetAllFormValidation();
            }
        } else if (currentCard === 3) {
            if (this.state.currentPassword === "") {
                this.setState({
                    cardThreeValidation: {
                        valid: false, field: -1, msg: 'Current Password Required'
                    }
                });
                return;
            } else if (this.state.newPassword === "") {
                this.setState({
                    cardThreeValidation: {
                        valid: false, field: -1, msg: 'New Password Required'
                    }
                });
                return;
            } else if (this.state.confirmNewPassword === "") {
                this.setState({
                    cardThreeValidation: {
                        valid: false, field: -1, msg: 'Confirm New Password Required'
                    }
                });
                return;
            } else if (this.state.newPassword !== this.state.confirmNewPassword) {
                this.setState({
                    cardThreeValidation: {
                        valid: false, field: -1, msg: 'New password and confirm password both should be same'
                    }
                });
                return;
            }
            this.props.accountUpdate({
                // userId: login.id,
                // uniqueId: login.uniqueId,
                uniqueId: login.xpr_user_id,
                updateType: 'password',
                password: {
                    cpassword: this.state.currentPassword,
                    nPassword: this.state.newPassword,
                    rpassword: this.state.confirmNewPassword
                }
            });
            this.resetAllFormValidation();
        } else if (currentCard === 4) {
            if (this.state.employeeData) {
                if (this.state.employeeData.dob === "") {
                    this.setState({
                        cardFourValidation: {
                            valid: false, msg: 'Date of birth is required'
                        }
                    });
                    return;
                }
                this.props.accountUpdate({
                    // userId: login.id,
                    // uniqueId: login.uniqueId,
                    uniqueId: login.xpr_user_id,
                    updateType: 'dob',
                    dob: this.state.employeeData.dob
                });
                this.resetAllFormValidation();
            }
        } else if (currentCard === 5) {
            if (this.state.employeeData) {
                if (this.state.employeeData.gender === "") {
                    // no possible condition.
                }
                this.props.accountUpdate({
                    // userId: login.id,
                    // uniqueId: login.uniqueId,
                    uniqueId: login.xpr_user_id,
                    updateType: 'gender',
                    gender: this.state.employeeData.gender
                });
                this.resetAllFormValidation();
            }
            this.resetAllFormValidation();
        } else if (currentCard === 6) {
            if (this.state.address.trim() === "") {
                this.setState({ cardSixValidaiton: { valid: false, msg: 'Address required' } });
                return;
            } else if (this.state.country.trim() === "") {
                this.setState({ cardSixValidaiton: { valid: false, msg: 'Country Required' } });
                return;
            } else if (this.state.province.trim() === "") {
                if (this.state.country === 'Canada') {
                    this.setState({ cardSixValidaiton: { valid: false, msg: 'Province required' } });
                } else {
                    this.setState({ cardSixValidaiton: { valid: false, msg: 'State required' } });
                }
                return;
            } else if (this.state.city.trim() === "") {
                this.setState({ cardSixValidaiton: { valid: false, msg: 'City required' } });
                return;
            } else if (this.state.postalcode.trim() === "") {
                this.setState({ cardSixValidaiton: { valid: false, msg: 'Postal code required' } });
                return;
            } else if (this.state.country.trim() !== "" && !addressMaster.postalRegexByCountry[this.state.country].test(this.state.postalcode)) {
                this.setState({ cardSixValidaiton: { valid: false, msg: 'Invalid postal code.' } });
                return;
            }
            this.props.accountUpdate({
                // userId: login.id,
                // uniqueId: login.uniqueId,
                uniqueId: login.xpr_user_id,
                updateType: 'address',
                address: {
                    addressline1: this.state.address.trim(),
                    addressline2: '', country: this.state.country.trim(),
                    city: this.state.city.trim(),
                    state: this.state.province.trim(), postalCode: this.state.postalcode.trim()
                }
            });
            this.resetAllFormValidation();
        }
    }
    shouldComponentUpdate(nextProps: Props, nextState: any) {
        if (this.props !== nextProps) {
            if (nextProps.employeeDataState.error !== null) {
                if (nextProps.employeeDataState.error.status && nextProps.employeeDataState.error.status.error === true) {
                    toast.error(nextProps.employeeDataState.error.status.msg);
                } else {
                    toast.error('Error Occured');
                }
            } else {
                if (nextProps.employeeDataState.pending === false) {
                    if (nextProps.employeeDataState.employeeDataResponse && nextProps.employeeDataState.employeeDataResponse! == nextProps.employeeDataState.employeeDataResponse) {
                        this.setState({
                            originalEmployeeData: JSON.parse(JSON.stringify(nextProps.employeeDataState.employeeDataResponse))
                        });
                        let maskedText = '';
                        let phone: any = nextProps.employeeDataState.employeeDataResponse.phone;
                        if (phone && phone !== "") {
                            if (phone[0] === "+") {
                                phone = phone.substr(2, phone);
                            }
                            maskedText = maskUSPhoneInput(phone);
                        }
                        this.setState({
                            employeeData: {
                                ...nextProps.employeeDataState.employeeDataResponse,
                                phone: maskedText
                            },
                            address: nextProps.employeeDataState.employeeDataResponse.addressline1 + " " + nextProps.employeeDataState.employeeDataResponse.addressline2,
                            country: nextProps.employeeDataState.employeeDataResponse.country,
                            city: nextProps.employeeDataState.employeeDataResponse.city,
                            province: nextProps.employeeDataState.employeeDataResponse.state,
                            postalcode: nextProps.employeeDataState.employeeDataResponse.postalCode,
                        });
                        if (addressMaster.states[nextProps.employeeDataState.employeeDataResponse.country]) {
                            this.setState({ provinceArray: addressMaster.states[nextProps.employeeDataState.employeeDataResponse.country] });
                        } else {
                            this.setState({ provinceArray: [] });
                        }
                    }
                    if (nextProps.employeeDataState.accountUpdateResponse &&
                        nextProps.employeeDataState.accountUpdateResponse.status && nextProps.employeeDataState.accountUpdateResponse.status.error === false) {
                        toast.success(nextProps.employeeDataState.accountUpdateResponse.status.msg);
                        this.setState({
                            currentActiveCard: -1, newEmailAddress: '', confirmNewEmailAddress: '',
                            currentPassword: '', newPassword: '', confirmNewPassword: '',
                        });
                        nextProps.employeeDataState.accountUpdateResponse = undefined;
                    }
                    if (nextProps.employeeDataState.emailVerificationResponse
                        && nextProps.employeeDataState.emailVerificationResponse.status.error === false) {
                        this.setState({ emailVerificationLoader: false });
                        toast.success(nextProps.employeeDataState.emailVerificationResponse.status.msg);
                    } else {
                        this.setState({ emailVerificationLoader: false });
                    }
                }
            }
        }
        return true;
    }
    componentDidUpdate() {
        this.props.employeeDataState.error = null;
        if (this.props.employeeDataState.emailVerificationResponse) {
            this.props.employeeDataState.emailVerificationResponse.status.error = true;
        }
    }
    handleEmailVerifyClick() {
        if (this.state.originalEmployeeData) {
            this.setState({ emailVerificationLoader: true });
            this.props.emailVerification({
                modelType: 'employee', modelUniqueid: this.state.originalEmployeeData.uniqueId,
                email: this.state.originalEmployeeData.email
            });
        }
    }
    sendVerificationCode() {
        if (this.state.originalEmployeeData) {
            this.setState({ loadingVerification: true });
            Axios.post(apiConfigs.API_URL + 'phoneverify/' + 'employee/' + this.state.originalEmployeeData.uniqueId + '/', {
                phone: this.state.originalEmployeeData.phone
            }, {
                headers: attachHeader(),
                withCredentials: true
            }).then((success) => {
                this.setState({ loadingVerification: false });
                if (success.status === 200) {
                    if (success.data.status.error === false) {
                        toast.success(success.data.status.msg);
                        this.setState({ phoneVerifyModal: true, verificationCodeFalse: false });
                        this.interval = setInterval(() => {
                            if (this.state.intervalTime === 0) {
                                clearInterval(this.interval);
                            } else {
                                this.setState({ intervalTime: this.state.intervalTime - 1 });
                            }
                        }, 1000)
                    } else {
                        toast.error(success.data.status.msg);
                    }
                }
            }, (error) => {
                this.setState({ loadingVerification: false });
                toast.error('Something went wrong');
            });
        }
    }
    verifyCode() {
        if (this.state.originalEmployeeData) {
            this.setState({ loadingVerification: true });
            Axios.post(apiConfigs.API_URL + 'verification/' + 'employee/' + this.state.originalEmployeeData.uniqueId + '/', {
                phone: this.state.originalEmployeeData.phone,
                code: this.state.verificationCode
            }, {
                headers: attachHeader(),
                withCredentials: true
            }).then((success) => {
                this.setState({ loadingVerification: false });
                if (success.status === 200) {
                    if (success.data.status.error === false) {
                        toast(success.data.status.msg);
                        this.setState({ phoneVerifyModal: false, verificationCodeFalse: false });
                        if (this.props.employeeDataState.employeeDataResponse) {
                            this.props.employeeDataState.employeeDataResponse.phoneVerified = new Date().toString();
                            if (this.state.originalEmployeeData && this.state.employeeData) {
                                this.setState({
                                    originalEmployeeData: {
                                        ...this.state.originalEmployeeData,
                                        phoneVerified: new Date().toString()
                                    },
                                    employeeData: {
                                        ...this.state.employeeData,
                                        phoneVerified: new Date().toString()
                                    }
                                })
                            }
                        }
                    } else {
                        this.setState({ verificationCodeFalse: true });
                    }
                }
            }, (error) => {
                this.setState({ loadingVerification: false });
                toast.error('Something went wrong');
            });
        }
    }
    render() {
        let today: any = new Date();
        let dd: any = today.getDate();
        let mm: any = today.getMonth() + 1; //January is 0!
        let yyyy: any = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm
        }

        today = yyyy + '-' + mm + '-' + dd;
        return (
            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDuration={1000} isVisible={true}>
                <section className="account-settings pantient-view">
                    <Helmet><title>{TITLES_LABELS.META.ACCOUNT}</title></Helmet>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <h4 className="page-title">Account Settings</h4>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="account-fields">
                                    {
                                        this.state.currentActiveCard === 0 ?
                                            null :
                                            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDelay={100} isVisible={true}>
                                                <div className="ac-field-value media">
                                                    <div className="media-body">
                                                        <div className="ac-title">Name</div>
                                                        <div className="ac-value">
                                                            {
                                                                (this.state.originalEmployeeData && this.state.originalEmployeeData.firstName && this.state.originalEmployeeData.lastName) ? (this.state.originalEmployeeData.firstName + " " + this.state.originalEmployeeData.lastName) : ''
                                                            }
                                                        </div>
                                                    </div>
                                                    <a href="javascript:void(0);" className="ml-3 edit-btn align-self-center" onClick={(e) => {
                                                        this.setState({ currentActiveCard: 0 });
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                    }}>Edit</a>
                                                </div>
                                            </Animated>
                                    }
                                    {
                                        this.state.currentActiveCard === 0 &&

                                        <Animated animationIn="fadeIn" animationOut="zoomOut" animationInDuration={1000} isVisible={true}>
                                            <div className="ac-form">
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <label htmlFor="fname">First Name</label>
                                                        <input type="text" className="form-control" placeholder="First name" id="fname"
                                                            onInput={(e: any) => {
                                                                if (this.state.employeeData) {
                                                                    this.setState({
                                                                        employeeData: {
                                                                            ...this.state.employeeData,
                                                                            firstName: e.target.value
                                                                        }
                                                                    })
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                if (this.state.employeeData) {
                                                                    this.setState({
                                                                        employeeData: {
                                                                            ...this.state.employeeData,
                                                                            firstName: e.target.value
                                                                        }
                                                                    })
                                                                }
                                                            }}
                                                            value={(this.state.employeeData && this.state.employeeData.firstName) ? this.state.employeeData.firstName : ''} />
                                                        {
                                                            (this.state.cardZeroValidation.valid === false && this.state.cardZeroValidation.field === 0) &&
                                                            <Animated animationIn="fadeIn" animationOut="zoomOut" animationInDuration={1000} isVisible={true}>
                                                                <div className="text-danger error">{this.state.cardZeroValidation.msg}</div>
                                                            </Animated>
                                                        }
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label htmlFor="lname">Last Name</label>
                                                        <input type="text" className="form-control" placeholder="Last name" id="lname"
                                                            onInput={(e: any) => {
                                                                if (this.state.employeeData) {
                                                                    this.setState({
                                                                        employeeData: {
                                                                            ...this.state.employeeData,
                                                                            lastName: e.target.value
                                                                        }
                                                                    })
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                if (this.state.employeeData) {
                                                                    this.setState({
                                                                        employeeData: {
                                                                            ...this.state.employeeData,
                                                                            lastName: e.target.value
                                                                        }
                                                                    })
                                                                }
                                                            }}
                                                            value={(this.state.employeeData && this.state.employeeData.lastName) ? this.state.employeeData.lastName : ''} />
                                                        {
                                                            (this.state.cardZeroValidation.valid === false && this.state.cardZeroValidation.field === 1) &&
                                                            <Animated animationIn="fadeIn" animationOut="zoomOut" animationInDuration={1000} isVisible={true}>
                                                                <div className="text-danger error">{this.state.cardZeroValidation.msg}</div>
                                                            </Animated>
                                                        }
                                                    </div>
                                                </div>

                                                <button type="button" className="btn btn-save btn-custom mr-3"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => { this.handleFormClick(this.state.currentActiveCard) }}>
                                                    {TITLES_LABELS.ACCOUNT.SAVE_BUTTON}
                                                    {
                                                        this.props.employeeDataState.pending &&
                                                        <span className="aft_load right">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    }
                                                </button>
                                                <button type="button" className="btn btn-cancel btn-custom"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => {
                                                        this.setState({
                                                            currentActiveCard: -1,
                                                        });
                                                        this.resetAllFormValidation();
                                                        this.resetAllFormData();
                                                        if (this.state.employeeData) {
                                                            this.setState({
                                                                employeeData: {
                                                                    ...this.state.employeeData,
                                                                    firstName: (this.state.originalEmployeeData && this.state.originalEmployeeData.firstName) ? this.state.originalEmployeeData.firstName : '',
                                                                    lastName: (this.state.originalEmployeeData && this.state.originalEmployeeData.lastName) ? this.state.originalEmployeeData.lastName : ''
                                                                }
                                                            });
                                                        }
                                                    }
                                                    }>{TITLES_LABELS.ACCOUNT.CANCEL_BUTTON}</button>

                                            </div>
                                        </Animated>
                                    }
                                </div>
                                <div className="account-fields d-none">
                                    {
                                        this.state.currentActiveCard === 1 ?
                                            null :
                                            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDelay={100} isVisible={true}>
                                                <div className="ac-field-value media">
                                                    <div className="media-body">
                                                        <div className="ac-title">Phone Number</div>
                                                        <div className="ac-value">{/* +1 647-123-4545  */}{(this.state.originalEmployeeData && this.state.originalEmployeeData.phone) ? this.state.originalEmployeeData.phone : ''}
                                                            {
                                                                (this.state.originalEmployeeData && this.state.originalEmployeeData.phoneVerified && this.state.originalEmployeeData.phoneVerified !== "") ?
                                                                    <label className="varification-status verified">Verified</label>
                                                                    :
                                                                    <>
                                                                        <label className="varification-status unverified">Unverified</label>
                                                                        <label className="varification-status verify cs_point" onClick={(e) => { this.sendVerificationCode() }}>
                                                                            Verify
                                                                            {
                                                                                (this.state.loadingVerification && !this.state.phoneVerifyModal) &&
                                                                                <span className="aft_load right">
                                                                                    <Spinner
                                                                                        as="span"
                                                                                        animation="border"
                                                                                        size="sm"
                                                                                        role="status"
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                </span>
                                                                            }
                                                                        </label>
                                                                    </>
                                                            }
                                                        </div>

                                                    </div>
                                                    <a className="ml-3 edit-btn align-self-center" href="javascript:void(0);" onClick={(e) => {
                                                        this.setState({ currentActiveCard: 1 });
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                    }}>Edit</a>
                                                </div>
                                            </Animated>
                                    }
                                    {
                                        this.state.currentActiveCard === 1 &&
                                        <Animated animationIn="fadeIn" animationOut="zoomOut" animationInDuration={1000} isVisible={true}>
                                            <div className="ac-form">
                                                <div className="form-group">
                                                    <label htmlFor="fname">Phone Number</label>
                                                    <input type="tel" className="form-control"
                                                        onInput={(e: any) => {
                                                            if (this.state.employeeData) {
                                                                if (e.target.value[0] === "+") {
                                                                    e.target.value = e.target.value.substr(2, e.target.value.length);
                                                                }
                                                                const maskedText = maskUSPhoneInput(e.target.value);
                                                                this.setState({
                                                                    employeeData: {
                                                                        ...this.state.employeeData,
                                                                        phone: maskedText
                                                                    }
                                                                })
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            if (this.state.employeeData) {
                                                                if (e.target.value[0] === "+") {
                                                                    e.target.value = e.target.value.substr(2, e.target.value.length);
                                                                }
                                                                const maskedText = maskUSPhoneInput(e.target.value);
                                                                this.setState({
                                                                    employeeData: {
                                                                        ...this.state.employeeData,
                                                                        phone: maskedText
                                                                    }
                                                                })
                                                            }
                                                        }}
                                                        value={
                                                            (this.state.employeeData && this.state.employeeData.phone) ?
                                                                this.state.employeeData.phone
                                                                : ''} />
                                                    {
                                                        (this.state.cardOneValidation.valid === false) &&
                                                        <div className="text-danger error">{this.state.cardOneValidation.msg}</div>
                                                    }
                                                </div>
                                                <button type="button" className="btn btn-save btn-custom mr-3"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => { this.handleFormClick(1) }}>
                                                    {TITLES_LABELS.ACCOUNT.SAVE_BUTTON}
                                                    {
                                                        this.props.employeeDataState.pending &&
                                                        <span className="aft_load right">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    }

                                                </button>
                                                <button type="button" className="btn btn-cancel btn-custom"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => {
                                                        this.setState({ currentActiveCard: -1 });
                                                        this.resetAllFormValidation();
                                                        this.resetAllFormData();
                                                        if (this.state.employeeData) {
                                                            this.setState({
                                                                employeeData: {
                                                                    ...this.state.employeeData,
                                                                    phone: (this.state.originalEmployeeData && this.state.originalEmployeeData.phone) ? this.state.originalEmployeeData.phone : '',
                                                                }
                                                            });
                                                        }
                                                    }}>{TITLES_LABELS.ACCOUNT.CANCEL_BUTTON}</button>
                                            </div>
                                        </Animated>
                                    }
                                </div>
                                <div className="account-fields">
                                    {
                                        this.state.currentActiveCard === 2 ?
                                            null :
                                            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDelay={100} isVisible={true}>
                                                <div className="ac-field-value media">
                                                    <div className="media-body">
                                                        <div className="ac-title">Email</div>
                                                        <div className="ac-value">{(this.state.originalEmployeeData && this.state.originalEmployeeData.email) ? this.state.originalEmployeeData.email : ''}
                                                            {
                                                                (this.state.originalEmployeeData && this.state.originalEmployeeData.emailVerified && this.state.originalEmployeeData.emailVerified !== "") ?
                                                                    <label className="varification-status verified d-none">Verified</label> :
                                                                    <>
                                                                        <label className="varification-status unverified d-none">Unverified</label>
                                                                        <label className="varification-status verify cs_point d-none" onClick={(e) => {
                                                                            this.handleEmailVerifyClick();
                                                                        }}>Resend
                                                                            {
                                                                                this.state.emailVerificationLoader &&
                                                                                <span className="aft_load right">
                                                                                    <Spinner
                                                                                        as="span"
                                                                                        animation="border"
                                                                                        size="sm"
                                                                                        role="status"
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                </span>
                                                                            }
                                                                        </label>
                                                                    </>
                                                            }
                                                        </div>

                                                    </div>
                                                    <a className="ml-3 edit-btn align-self-center" href="javascript:void(0);" onClick={(e) => {
                                                        this.setState({ currentActiveCard: 2 });
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                    }}>Edit</a>
                                                </div>
                                            </Animated>
                                    }
                                    {
                                        this.state.currentActiveCard === 2 &&
                                        <Animated animationIn="fadeIn" animationOut="zoomOut" animationInDuration={1000} isVisible={true}>
                                            <div className="ac-form">
                                                <div className="form-group">
                                                    <label>New Email</label>
                                                    <input type="email" className="form-control"
                                                        onInput={(e: any) => {
                                                            this.setState({ newEmailAddress: e.target.value });
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ newEmailAddress: e.target.value });
                                                        }}
                                                        value={this.state.newEmailAddress} />
                                                    {
                                                        (this.state.cardTwoValidation.valid === false && this.state.cardTwoValidation.field === 0) &&
                                                        <div className="text-danger error">{this.state.cardTwoValidation.msg}</div>
                                                    }
                                                </div>
                                                <div className="form-group">
                                                    <label>Confirm New Email</label>
                                                    <input type="email" className="form-control"
                                                        onInput={(e: any) => {
                                                            this.setState({ confirmNewEmailAddress: e.target.value });
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ confirmNewEmailAddress: e.target.value });
                                                        }}
                                                        value={this.state.confirmNewEmailAddress} />
                                                    {
                                                        (this.state.cardTwoValidation.valid === false && this.state.cardTwoValidation.field === 1) &&
                                                        <div className="text-danger error">{this.state.cardTwoValidation.msg}</div>
                                                    }
                                                </div>
                                                <button type="button" className="btn btn-save btn-custom mr-3"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => { this.handleFormClick(2) }}>
                                                    {TITLES_LABELS.ACCOUNT.SAVE_BUTTON}
                                                    {
                                                        this.props.employeeDataState.pending &&
                                                        <span className="aft_load right">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    }
                                                </button>
                                                <button type="button" className="btn btn-cancel btn-custom"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => {
                                                        this.resetAllFormValidation();
                                                        this.resetAllFormData();
                                                        this.setState({
                                                            currentActiveCard: -1,
                                                            newEmailAddress: '', confirmNewEmailAddress: ''
                                                        });
                                                    }}>{TITLES_LABELS.ACCOUNT.CANCEL_BUTTON}</button>
                                            </div>
                                        </Animated>
                                    }
                                </div>
                                <div className="account-fields">
                                    {
                                        this.state.currentActiveCard === 3 ?
                                            null :
                                            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDelay={100} isVisible={true}>
                                                <div className="ac-field-value media">
                                                    <div className="media-body">
                                                        <div className="ac-title">Password</div>
                                                        <div className="ac-value">**********</div>
                                                    </div>
                                                    <a className="ml-3 edit-btn align-self-center" href="javascript:void(0);" onClick={(e) => {
                                                        this.setState({ currentActiveCard: 3 });
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                    }}>Edit</a>
                                                </div>
                                            </Animated>
                                    }
                                    {
                                        this.state.currentActiveCard === 3 &&
                                        <Animated animationIn="fadeIn" animationOut="zoomOut" animationInDuration={1000} isVisible={true}>
                                            <div className="ac-form">
                                                <div className="form-group">
                                                    <label>Current Password</label>
                                                    <input type="password" className="form-control"
                                                        onInput={(e: any) => {
                                                            this.setState({ currentPassword: e.target.value })
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ currentPassword: e.target.value })
                                                        }}
                                                        value={this.state.currentPassword} />
                                                </div>
                                                <div className="form-group">
                                                    <label>New Password</label>
                                                    <input type="password" className="form-control"
                                                        onInput={(e: any) => {
                                                            this.setState({ newPassword: e.target.value })
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ newPassword: e.target.value })
                                                        }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Confirm New Password</label>
                                                    <input type="password" className="form-control"
                                                        onInput={(e: any) => {
                                                            this.setState({ confirmNewPassword: e.target.value })
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ confirmNewPassword: e.target.value })
                                                        }} />
                                                    {
                                                        (this.state.cardThreeValidation.valid === false) &&
                                                        <div className="text-danger error">{this.state.cardThreeValidation.msg}</div>
                                                    }
                                                </div>
                                                <button type="button" className="btn btn-save btn-custom mr-3"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => { this.handleFormClick(3) }}>
                                                    {TITLES_LABELS.ACCOUNT.SAVE_BUTTON}
                                                    {
                                                        this.props.employeeDataState.pending &&
                                                        <span className="aft_load right">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    }
                                                </button>
                                                <button type="button" className="btn btn-cancel btn-custom"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => {
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                        this.setState({
                                                            currentActiveCard: -1,
                                                            newPassword: '', confirmNewPassword: '', currentPassword: ''
                                                        });
                                                    }}>{TITLES_LABELS.ACCOUNT.CANCEL_BUTTON}</button>
                                            </div>
                                        </Animated>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="account-fields">
                                    {
                                        this.state.currentActiveCard === 4 ?
                                            null :
                                            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDelay={100} isVisible={true}>
                                                <div className="ac-field-value media">
                                                    <div className="media-body">
                                                        <div className="ac-title">Date of Birth</div>
                                                        <div className="ac-value">
                                                            {(this.state.originalEmployeeData && this.state.originalEmployeeData.dob) ?
                                                                new Date(this.state.originalEmployeeData.dob).getDate() + "-" +
                                                                this.monthNames[new Date(this.state.originalEmployeeData.dob).getMonth()] + "-" +
                                                                new Date(this.state.originalEmployeeData.dob).getFullYear()
                                                                : ''}
                                                        </div>
                                                    </div>
                                                    <a className="ml-3 edit-btn align-self-center" href="javascript:void(0);" onClick={(e) => {
                                                        this.setState({ currentActiveCard: 4 });
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                    }}>Edit</a>
                                                </div>
                                            </Animated>
                                    }
                                    {
                                        this.state.currentActiveCard === 4 &&
                                        <Animated animationIn="fadeIn" animationOut="zoomOut" animationInDuration={1000} isVisible={true}>
                                            <div className="ac-form">
                                                <div className="form-group">
                                                    <label>Select date</label>
                                                    <div className="form-group">
                                                        <input type="date" className="form-control"
                                                            max={today}
                                                            value={(this.state.employeeData && this.state.employeeData.dob) ? this.state.employeeData.dob : ''}
                                                            onChange={(e: any) => {
                                                                const dobSelected: string = e.target.value;
                                                                if (this.state.employeeData) {
                                                                    this.setState({
                                                                        ...this.state,
                                                                        employeeData: {
                                                                            ...this.state.employeeData,
                                                                            dob: dobSelected
                                                                        }
                                                                    })
                                                                }
                                                            }} />
                                                        {
                                                            this.state.cardFourValidation.valid === false &&
                                                            <div className="text-danger error">{this.state.cardFourValidation.msg}</div>
                                                        }
                                                    </div>
                                                </div>
                                                <button type="button" className="btn btn-save btn-custom mr-3"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => { this.handleFormClick(4) }}>
                                                    {TITLES_LABELS.ACCOUNT.SAVE_BUTTON}
                                                    {
                                                        this.props.employeeDataState.pending &&
                                                        <span className="aft_load right">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    }
                                                </button>
                                                <button type="button" className="btn btn-cancel btn-custom"
                                                    disabled={this.props.employeeDataState.pending}
                                                    onClick={(e) => { this.resetAllFormValidation(); this.resetAllFormData(); this.setState({ currentActiveCard: -1 }); }}>{TITLES_LABELS.ACCOUNT.CANCEL_BUTTON}</button>
                                            </div>
                                        </Animated>
                                    }
                                </div>
                                <div className="account-fields">
                                    {
                                        this.state.currentActiveCard === 5 ?
                                            null :
                                            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDelay={100} isVisible={true}>
                                                <div className="ac-field-value media">
                                                    <div className="media-body">
                                                        <div className="ac-title">Gender</div>
                                                        <div className="ac-value">{
                                                            (this.state.originalEmployeeData && this.state.originalEmployeeData.gender) ?
                                                                this.state.originalEmployeeData.gender : ''
                                                        }</div>
                                                    </div>
                                                    <a className="ml-3 edit-btn align-self-center" href="javascript:void(0);" onClick={(e) => {
                                                        this.setState({ currentActiveCard: 5 });
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                    }}>Edit</a>
                                                </div>
                                            </Animated>
                                    }
                                    {
                                        this.state.currentActiveCard === 5 &&

                                        <div className="ac-form">
                                            <div className="form-group">
                                                <label>Gender</label>
                                                <div className="form-group">
                                                    <div className="form-group">
                                                        <select className="form-control"
                                                            onChange={(e) => {
                                                                const genderSelected: string = e.target.value;
                                                                if (this.state.employeeData) {
                                                                    this.setState({
                                                                        ...this.state,
                                                                        employeeData: {
                                                                            ...this.state.employeeData,
                                                                            gender: genderSelected
                                                                        }
                                                                    })
                                                                }
                                                            }}
                                                            value={(this.state.employeeData && this.state.employeeData.gender) ? this.state.employeeData.gender : ''}>
                                                            <option value='Male'>Male</option>
                                                            <option value='Female'>Female</option>
                                                            {/* <option value="">Prefer not to say</option> */}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" className="btn btn-save btn-custom mr-3"
                                                disabled={this.props.employeeDataState.pending}
                                                onClick={(e) => { this.handleFormClick(5) }}>
                                                {TITLES_LABELS.ACCOUNT.SAVE_BUTTON}
                                                {
                                                    this.props.employeeDataState.pending &&
                                                    <span className="aft_load right">
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                }
                                            </button>
                                            <button type="button" className="btn btn-cancel btn-custom"
                                                disabled={this.props.employeeDataState.pending}
                                                onClick={(e) => { this.resetAllFormValidation(); this.resetAllFormData(); this.setState({ currentActiveCard: -1 }); }}>{TITLES_LABELS.ACCOUNT.CANCEL_BUTTON}</button>
                                        </div>
                                    }
                                </div>
                                <div className="account-fields d-none">
                                    {
                                        this.state.currentActiveCard === 6 ?
                                            null :
                                            <Animated animationIn="fadeIn" animationOut="fadeIn" animationInDelay={100} isVisible={true}>
                                                <div className="ac-field-value media">
                                                    <div className="media-body">
                                                        <div className="ac-title">Address</div>
                                                        <div className="ac-value w-50">
                                                            {
                                                                (this.state.originalEmployeeData) ?
                                                                    <>
                                                                        <label>
                                                                            {
                                                                                this.state.originalEmployeeData.addressline1 !== "" ? <>{this.state.originalEmployeeData.addressline1 + ","}&nbsp;</> : ' '
                                                                            }
                                                                        </label>
                                                                        <label>
                                                                            {
                                                                                this.state.originalEmployeeData.addressline2 !== "" ? <>{this.state.originalEmployeeData.addressline2 + ","}&nbsp;</> : ' '
                                                                            }
                                                                        </label>
                                                                        <label>
                                                                            {this.state.originalEmployeeData.city !== "" ? <>{this.state.originalEmployeeData.city + ","}&nbsp;</> : ' '}
                                                                        </label>
                                                                        <label>{this.state.originalEmployeeData.state !== "" ? <>{this.state.originalEmployeeData.state + ","}&nbsp;</> : ' '}</label>
                                                                        <label>{this.state.originalEmployeeData.country !== "" ? <>{this.state.originalEmployeeData.country + ","}&nbsp;</> : ' '}</label>
                                                                        <label>{this.state.originalEmployeeData.postalCode !== "" ? this.state.originalEmployeeData.postalCode : ' '}</label>
                                                                    </>
                                                                    : ''
                                                            }
                                                        </div>
                                                    </div>
                                                    <a className="ml-3 edit-btn align-self-center" href="javascript:void(0);" onClick={(e) => {
                                                        this.setState({ currentActiveCard: 6 });
                                                        this.resetAllFormData();
                                                        this.resetAllFormValidation();
                                                    }}>Edit</a>
                                                </div>
                                            </Animated>
                                    }
                                    {
                                        this.state.currentActiveCard === 6 &&
                                        <div className="ac-form">
                                            <div className="form-group">
                                                <label>Address</label>
                                                <input type="text" className="form-control"
                                                    placeholder="Apartment, suite, unit, floor, etc... (Optional)" value={this.state.address}
                                                    onInput={(e: any) => {
                                                        this.setState({ address: e.target.value })
                                                    }}
                                                    onChange={(e) => {
                                                        this.setState({ address: e.target.value })
                                                    }} />
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="fname">Country</label>
                                                    <select className="form-control" value={this.state.country} onChange={
                                                        (e) => {
                                                            this.setState({ country: e.target.value });
                                                            if (addressMaster.states[e.target.value]) {
                                                                this.setState({ provinceArray: addressMaster.states[e.target.value] });
                                                            } else {
                                                                this.setState({ provinceArray: [] });
                                                            }
                                                        }
                                                    }>
                                                        <option value="">Select Country</option>
                                                        {
                                                            addressMaster.countries.map((value: any, index: any) => {
                                                                return (
                                                                    <option value={value} key={index}>{value}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="lname">{
                                                        (this.state.country === 'Canada') ?
                                                            <>Province</> : <>State</>
                                                    }</label>
                                                    <select className="form-control" value={this.state.province} onChange={
                                                        (e) => {
                                                            this.setState({ province: e.target.value });
                                                        }
                                                    }>
                                                        {
                                                            (this.state.country === 'Canada') ?
                                                                <option value="">Select Province</option> : <option value="">Select State</option>
                                                        }
                                                        {
                                                            this.state.provinceArray.map((value, index) => {
                                                                return (
                                                                    <option value={value} key={index}>{value}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label>City</label>
                                                    <input type="text" className="form-control"
                                                        onInput={(e: any) => {
                                                            this.setState({ city: e.target.value });
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ city: e.target.value });
                                                        }}
                                                        value={this.state.city} />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label>{
                                                        (this.state.country === 'Canada') ?
                                                            <>Postal Code</> : <>Zip Code</>
                                                    }</label>
                                                    <input type="text" className="form-control"
                                                        onInput={(e: any) => {
                                                            this.setState({ postalcode: e.target.value });
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ postalcode: e.target.value });
                                                        }}
                                                        placeholder={(this.state.country === 'Canada' ? 'Postal Code' : 'Zip Code')} value={this.state.postalcode} />
                                                </div>
                                            </div>
                                            {
                                                (this.state.cardSixValidaiton.valid === false) &&
                                                <div className="text-danger error">{this.state.cardSixValidaiton.msg}</div>
                                            }
                                            <button type="button" className="btn btn-save btn-custom mr-3"
                                                disabled={this.props.employeeDataState.pending}
                                                onClick={(e) => { this.handleFormClick(6) }}>
                                                {TITLES_LABELS.ACCOUNT.SAVE_BUTTON}
                                                {
                                                    this.props.employeeDataState.pending &&
                                                    <span className="aft_load right">
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                }
                                            </button>
                                            <button type="button" className="btn btn-cancel btn-custom"
                                                disabled={this.props.employeeDataState.pending}
                                                onClick={(e) => {
                                                    this.setState({ currentActiveCard: -1 });
                                                    this.resetAllFormData();
                                                    this.resetAllFormValidation();
                                                }}>{TITLES_LABELS.ACCOUNT.CANCEL_BUTTON}</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.state.phoneVerifyModal &&
                        <Modal centered className="phoneverify" show={this.state.phoneVerifyModal} onHide={() => {
                            this.setState({ phoneVerifyModal: false, verificationCodeFalse: false, intervalTime: 30 });
                            clearInterval(this.interval);
                        }}>
                            <div className="popup-sec">
                                <div className="popup-title text-center">
                                    Verify your number
                            </div>
                                <div className="popup-form text-center">
                                    <p>We have sent a verification code to <span>{this.state.originalEmployeeData ? this.state.originalEmployeeData.phone : ''}</span></p>
                                    <div className="form-txt">Enter code here</div>
                                    <div className="form-group">
                                        <PinInput
                                            length={4}
                                            initialValue={""}
                                            onChange={(value, index) => {
                                                this.setState({ verificationCode: value });
                                            }}
                                            type="numeric"
                                            style={{ padding: '10px' }}
                                            inputStyle={{}}
                                            inputFocusStyle={{ borderColor: 'blue' }}
                                            onComplete={(value, index) => {
                                                this.setState({ verificationCode: value });
                                            }}
                                        />
                                        {
                                            this.state.verificationCodeFalse &&
                                            <div className="text-danger error">Verification code entered is incorrect.</div>
                                        }
                                    </div>
                                    <button className="btn btn-custom send-btn"
                                        onClick={(e) => { this.verifyCode() }}
                                        disabled={this.state.verificationCode.length !== 4 || this.state.loadingVerification}>
                                        <img src={require('../../assets/images/ic_arrow_upward_24px.svg')} />
                                    </button>
                                    {
                                        this.state.intervalTime !== 0 &&
                                        <div className="resend-txt">Didn't received code? Resend after {this.state.intervalTime} seconds.</div>
                                    }
                                    {
                                        this.state.intervalTime === 0 &&
                                        <button className="btn resend-btn" onClick={(e) => { this.sendVerificationCode() }}>
                                            Resend Code
                                            {
                                                this.state.loadingVerification &&
                                                <span className="aft_load right">
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                            }
                                        </button>
                                    }
                                </div>
                            </div>
                        </Modal>
                    }
                </section>
            </Animated>
        )
    }
}
const mapDispatchToProps = (dispatch: any) => ({
    accountUpdate: (request: AccountUpdateRequest) => {
        dispatch(accountUpdatePending(request));
    },
    emailVerification: (request: EmailVerificationRequest) => {
        dispatch(emailVerificationPendingAction(request));
    }
});
const mapStateToProps = (state: IAppState) => ({
    employeeDataState: state.employeeData,
});
export default connect(mapStateToProps, mapDispatchToProps)(Account);